import React from 'react';
import { Route } from 'react-router-dom';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import LoadingPage from '../../components/Loading/LoadingPage';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import { ToastContainer } from 'react-toastify';
import LoadingComponent from '../../components/Loading/LoadingComponent';

const Router = ({ component: C, props: cProps, ready, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          {!ready && <LoadingPage />}
          <HeaderComponent />
          <C {...props} {...cProps} />
          <FooterComponent />
          <ToastContainer />
          <LoadingComponent />
        </Layout>
      )}
    />
  );
};

const mapStateToProps = state => ({
  ready: state.info.ready
});

export default connect(mapStateToProps)(Router);



// WEBPACK FOOTER //
// ./src/pages/layout/UnauthenticatedLayout.js